import { BaseText, Button, theme } from 'aimo-ui';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { StyledWrapper } from 'styles/ContainerStyles';
import { testIdentifiers } from 'utils/testIdentifiers';

interface WelcomeNotSignedProps {
  onLetsGoPress?: () => void;
  notSignedInText: string;
  setHeight: (h: number) => void;
}
const WelcomeNotSignedContent = ({
  onLetsGoPress,
  notSignedInText,
  setHeight,
}: WelcomeNotSignedProps) => {
  const { t } = useTranslation();
  const [isLayoutCalculated, setIsLayoutCalculated] = useState<boolean>(false);
  const componentRef = useRef<View>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isLayoutCalculated && componentRef.current) {
        componentRef.current.measure((_, __, w, h) => {
          setHeight(h + theme.normalising.heightPixel(30));
        });
      }
    }, 100);

    return () => clearTimeout(timeout);
  }, [setHeight, isLayoutCalculated]);

  const onLayoutHandler = () => {
    setIsLayoutCalculated(true);
  };

  return (
    <View ref={componentRef} onLayout={onLayoutHandler}>
      <StyledWrapper maxWidth={320} center mb={20} mt={30}>
        <BaseText center {...testIdentifiers('not-signed-in-text')}>
          {notSignedInText}
        </BaseText>
      </StyledWrapper>
      <StyledWrapper maxWidth={350} center mb={20}>
        <Button
          {...testIdentifiers('lets-go')}
          text={t('account.letsGo')}
          size="l"
          onPress={onLetsGoPress}
        />
      </StyledWrapper>
    </View>
  );
};

export default WelcomeNotSignedContent;
